<template>
  <div>
    <Header></Header>
    <div class="banner">
      <div class="word">
        <div class="containerTit">
          运营管理
        </div>
        <div class="line">
          ——
        </div>
      </div>
    </div>

     <div class="content">

        <div class="conBox" v-for="(item,idx) in list" :key="item.id">
          <template v-if="idx%2 === 0">
            <div class="conLeft">
              <div class="conTit">{{item.title}}</div>
              <div class="conBody">
                <p v-for="cItem in item.array" :key="cItem">{{cItem}}</p>
              </div>
            </div>
            <img class="conImg" :src="baseURL+item.image" />
          </template>
          <template v-else>
            <img class="conImg" :src="baseURL+item.image" />
            <div class="conLeft">
              <div class="conTit">{{item.title}}</div>
              <div class="conBody">
                <p v-for="cItem in item.array" :key="cItem">{{cItem}}</p>
              </div>
            </div>
          </template>

        </div>


        <!-- <div class="conBox">
          <img class="conImg" src="../../assets/images/op2.png" />
          <div class="conLeft">
           <div class="conTit">二级节点的保障工作</div>
            <div class="conBody">
              <p>二级节点应具备与标识运营管理相匹配的技术能力和其他所需条件，保证持续投入，保障解析服务的安全稳定运 行，与行业主管部门和国家顶级节点保持常态化联系。例如， 建立运行维护机制，保障二级节点的安全运行；建立专业运维团队，提供 7x24 小时运维服务；建立运维管理规范，保障服务可用性和准确性；建立信息安全管理、系统变更等方面的管理制度，按时进行安全及业务审计；建立应急管理机制、及时处理突发事件。建立和国家顶级节点的协同应急处置机制，有效应对并保障应急情况下服务提供。同时建立业务与运营月报制度，及时向国家顶级节点运行机构同步相关情况。</p>
              <p>二级节点责任主体可自行运营二级节点，也可委托第三方运营二级节点。二级节点委托运营或变更委托主体时，应及时向电信管理机构报备相关情况。二级节点委托运营的， 不影响二级节点主体责任归属。</p>
            </div>
          </div>
        </div>

        <div class="conBox">
          <div class="conLeft">
           <div class="conTit">二级节点的管理方法</div>
            <div class="conBody">
              <p>二级节点应具有健全的标识编码和服务管理制度，以及对企业节点的监督管理机制。</p>
              <p>二级节点应具备跨系统、跨企业、跨行业的标识解析应用方案，具有行业标识解析的商业模式，或为行业提供标识解析的公共应用支撑。 </p>
              <p>二级节点应根据相关要求每月向国家顶级节点报备运营情况，运营情况包括运营时长、服务SLA 指标、服务维护和紧急情况等内容。</p>
              <p>二级节点责任主体变更或退出经营的，应按要求向电信管理机构提出申请，并附相关方案。电信管理机构审核通过后，二级节点责任主体方可按流程变更或退出。</p>
            </div>
          </div>
          <img class="conImg" src="../../assets/images/op3.png" />
        </div> -->



      </div>
      <Contact />
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {serverUrl} from '@/utils/server.js'
  import Contact from './Contact.vue'
  import {
     contentByType
   } from '@/api/api'
  export default {
    data() {
      return {
        baseURL: serverUrl.baseURL,
        list:[]
      }
    },
    components: {
      Header,
      Footer,
      Contact
    },
    mounted() {
      this.getContentByType()
    },
    methods: {
      getContentByType() {
        contentByType({type: 4}).then(res=> {
          this.list = res.data
          // todo
        })
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 480px;
    background: url(../../assets/images/opBanner.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .containerTit{
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }
  .line {
    font-size: 16px;
    font-family: Adobe Heiti Std;
    color: #FFFFFF;
    line-height: 46px;
  }
  .word{
    width: 1300px;
    margin: 0 auto;
  }
  .conTit{
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-bottom: 60px;
  }
  .conBody{
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #7D889B;
    line-height: 30px;
  }
  .conBody p {
    margin: 0;
    margin-bottom: 20px;
    text-indent: 2rem;
  }
  .conBox{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 130px;
  }
  .conLeft{
    width: 650px;
  }
  .conImg{
    width: 600px;
  }
  .content{
    width: 1300px;
    margin: 0 auto 140px;
  }
</style>



// WEBPACK FOOTER //
// src/views/node/Operation.vue